import { AppMode } from './app-mode';

export interface ModeDetectorOptions {
  readonly subdomainPrefix?: string;
  readonly extraPlatformHosts?: readonly string[];
}

export function detectMode(
  host: string,
  rootDomain: string,
  opts: ModeDetectorOptions = {},
): AppMode {
  const normalized = host.toLowerCase().split(':')[0];

  const platformHosts = new Set<string>([
    rootDomain,
    `www.${rootDomain}`,
    `app.${rootDomain}`,
    ...(opts.extraPlatformHosts ?? []).map((h) => h.toLowerCase()),
  ]);
  if (platformHosts.has(normalized)) {
    return { kind: 'platform' };
  }

  const suffix = `.${rootDomain}`;
  if (normalized.endsWith(suffix)) {
    const label = normalized.slice(0, -suffix.length);
    if (label.length > 0 && !label.includes('.')) {
      const prefix = opts.subdomainPrefix;
      if (prefix) {
        if (label.startsWith(prefix) && label.length > prefix.length) {
          return { kind: 'tenant', subdomain: label.slice(prefix.length) };
        }
        return { kind: 'unknown' };
      }
      return { kind: 'tenant', subdomain: label };
    }
  }

  if (normalized === 'localhost' || normalized === '127.0.0.1') {
    return { kind: 'platform' };
  }

  return { kind: 'unknown' };
}
